module.exports = __webpack_public_path__ + "img/edge.2b2888b5.svg";